import { render, staticRenderFns } from "./StudentPathDialog.vue?vue&type=template&id=0f5630cd&scoped=true"
import script from "./StudentPathDialog.vue?vue&type=script&lang=js"
export * from "./StudentPathDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentPathDialog.vue?vue&type=style&index=0&id=0f5630cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5630cd",
  null
  
)

export default component.exports